export function insertPendoScript (pendoKey) {
  const pendoAlreadyEnabled =  document.getElementById('pendo-analytics');

  if (pendoAlreadyEnabled) {
    return;
  }

  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.setAttribute('id', 'pendo-analytics');
  s.text = `(function(apiKey){
  (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=[];
  v=['initialize','identify','updateOptions','pageLoad'];for(w=0,x=v.length;w<x;++w)(function(m){
  o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
  y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
  z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
  })('${pendoKey}');`

  document.head.appendChild(s);

  return true;
}

export function* initPendo(id, reading_origin) {
  try {
    const pendo = window.pendo || {}
    const pendoVisitorId = pendo.visitorId
    if (!pendoVisitorId) {
      pendo.initialize({ visitor: { id, reading_origin } });
    }
    return true;
  }
  catch (e) {
    console.error('Error while initializing Pendo', e.message)
  }
}

export function insertInstanaScript(instanaKey) {
  const instanaAlreadyEnabled =  document.getElementById('instana-analytics');

  if (instanaAlreadyEnabled) {
    return;
  }

  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.setAttribute('id', 'instana-analytics');
  s.text = `var h = document.location.host.split('.')[0];
  (function(s,t,a,n){s[t]||(s[t]=a,n=s[a]=function(){n.q.push(arguments)},
  n.q=[],n.v=2,n.l=1*new Date)})(window,"InstanaEumObject","ineum");
  ineum('reportingUrl', 'https://eum-red-saas.instana.io');
  ineum('key', '${instanaKey}');
  ineum('trackSessions');
  ineum('page', 'landing_' + h);`;
  document.head.appendChild(s);

  const sEum = document.createElement('script');
  sEum.type = 'text/javascript';
  sEum.setAttribute('id', 'instana-analytics-eum');
  sEum.setAttribute('crossorigin', 'anonymous');
  sEum.setAttribute('src', 'https://eum.instana.io/eum.min.js');

  document.head.appendChild(sEum);
}

export function insertLogglyScript(logglyKey) {
  const logglyAlreadyEnabled =  document.getElementById('loggly-analytics');

  if (logglyAlreadyEnabled) {
    return;
  }

  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.setAttribute('id', 'loggly-analytics');
  s.setAttribute('src', '//cloudfront.loggly.com/js/loggly.tracker-2.1.min.js');

  document.head.appendChild(s)

  const sConfig = document.createElement('script')
  sConfig.type = 'text/javascript';
  sConfig.setAttribute('id', 'loggly-analytics-tracker');
  sConfig.text = `var _LTracker = _LTracker || [];
  var config = {
    'logglyKey': '${logglyKey}',
    'sendConsoleErrors' : true,
    'tag' : 'ereader'
  };
  _LTracker.push(config);`;

  document.head.appendChild(sConfig);
}

export function insertArroyoScript(arroyoUrl) {
  const arroyoAlreadyEnabled =  document.getElementById('arroyo-analytics');

  if (arroyoAlreadyEnabled) {
    return;
  }

  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.setAttribute('id', 'arroyo-analytics');
  s.text = `(()=>{var e,_,o,n,r,t,A,E,O;e=window,_=document,o="script",n="${arroyoUrl}",r="_arroyo",
    t="Reading",A=console.log,e.AYO_BASE_URL=e.AYO_BASE_URL||n,n=new URL("/arroyo.js",e.AYO_BASE_URL).toString(),
    e.AYO_FUNC_NAME=r,e.AYO_SUBSYSTEM=t,e.AYO_LOG_FUNC=A,e[r]=e[r]||function(){(e[r].queue=e[r].queue||[]).push(arguments[0])},
    (E=_.createElement(o)).async=1,E.src=n,[O]=_.getElementsByTagName(o),O.parentNode.insertBefore(E,O)})();`;

  document.head.appendChild(s);
  return true;
}